<template>
  <div id="academic">
    <el-container>
      <el-aside width="200px">
        <div class="catalog">
          <h5 style="font-size: 20px" class="catalog-title">学术交流</h5>
          <el-menu
            :default-active="activeIndex"
            class="menu-left"
            :router="true"
          >
            <el-menu-item
              @click="saveNavState('/comnt&student/academic')"
              index="/comnt&student/academic"
            >
              <i class="el-icon-s-management"></i>
              <span slot="title">学术交流</span>
            </el-menu-item>
            <el-menu-item
              @click="saveNavState('/comnt&student/awards')"
              index="/comnt&student/awards"
            >
              <template slot="title">
                <i class="el-icon-document"></i>
                <span>学生奖项</span>
              </template>
            </el-menu-item>
<!--            <el-menu-item-->
<!--                @click="saveNavState('/comnt&student/activity')"-->
<!--                index="/comnt&student/activity"-->
<!--            >-->
<!--              <template slot="title">-->
<!--                <i class="el-icon-document"></i>-->
<!--                <span>学生活动</span>-->
<!--              </template>-->
<!--            </el-menu-item>-->
          </el-menu>
        </div>
      </el-aside>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "/comnt&student/academic", //默认
    };
  },

  created() {
    this.activeIndex = window.sessionStorage.getItem("ASactivePath");
    if(this.activeIndex !== null){
      this.saveNavState(this.activeIndex)
    } else {
      this.saveNavState("/comnt&student/academic")
    }
  },
  methods: {
    saveNavState(activePath) {
      window.sessionStorage.setItem("ASactivePath", activePath);
      this.activeIndex = activePath;
      this.$router.push(activePath)
    },
  },
  // created() {
  //   this.activeIndex = window.sessionStorage.getItem("activePath");
  // },
  // methods: {
  //   saveNavState(activePath) {
  //     console.log(this);
  //     window.sessionStorage.setItem("activePath", activePath);
  //     this.activeIndex = activePath;
  //   },
  // },
};
</script>

<style lang='less' scoped>
#academic {
  margin: 0 auto;
  .catalog {
    margin-top: 30px;
    .catalog-title {
      text-align: center;
    }
  }
}
</style>
